import React from 'react';
import ReactDropzone from "react-dropzone";

import "./all.css"

function FileState(props) {
    if(props.fileName.length && props.fileHash.length) {
        let link = `/get/${props.fileHash}`;
        return (
            <div className="flexRow">
                <span className={"filename"}>{props.fileName}</span>
                <span className={"link"}><a href={link}>{link}</a></span>
            </div>
        )
    }
    return (<div />)
}

export default class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {fileName: "", fileHash: "", busy: false};
    }

    fileUpload = (acceptedFiles) => {
        this.setState({busy: true});
        let fd = new FormData();
        fd.append('file', acceptedFiles[0]);
        fetch("/upload", {method: "POST", body: fd})
            .then(response => response.json(), onRejection => {
                return {"status": "failed"};
            })
            .then(dataJSON =>
            {
                if(dataJSON.status !== "failed") {
                    this.setState({fileName: dataJSON.filename, fileHash: dataJSON.hash, busy: false});
                } else {
                    this.setState({busy: false});
                }
            });
    };

    render () {
        return (
            <div className="everyContainer">
                <h1>Pliczek postaw se.</h1>
                <div className="divWithSuperPaddings">Wsadź pliczek poniżej, serwer zajmie się resztą (prawdopodobnie nawet poprawnie).</div>
                <ReactDropzone
                    onDrop={this.fileUpload}
                    disabled={this.state.busy}
                    multiple={false}
                >
                  {({getRootProps, getInputProps}) => (
                      <div {...getRootProps()} className="dropZone">
                        <input {...getInputProps()} />
                        <p className="textInsideDropzone">Wrzuć pliczek, będzie fajnie.</p>
                      </div>
                  )}
                </ReactDropzone>
                <FileState fileName={this.state.fileName} fileHash={this.state.fileHash} />
            </div>
        );
    }
}